<template>
  <div class="login container">
    <v-card id="login-card">
      <img id="logo" src="../assets/img/ft-logo.png"></img><br>
      <input type="text" v-model="email" placeholder="Email"><br>
      <input type="password" v-model="password" placeholder="Password"><br>
      <v-btn type="button" v-on:click="signIn" class="gray" id="signin-btn">Sign in</v-btn>
      <div id="gSignInWrapper">
        <div id="customBtn" v-on:click="signInWithGoogle" class="customGPlusSignIn">
          <span class="icon"></span>
          <span class="buttonText">Sign in with fictiontribe email</span>
        </div>
      </div>
      <p><router-link to="/reset-password">Forgot your password?</router-link></p>
    </v-card>
  </div>
</template>

<script>
  import firebase from 'firebase'
  import {store} from '../store/store.js'
  import Vuex from 'vuex'

  export default {
    name: 'login',
    data: function() {
      return {
        email: '',
        password: ''
      }
    },
    computed: {
      user() {
        return this.$store.getters.getUser;
      },
      isAdmin() {
        return this.$store.getters.getAdmin;
      }
    },
    store: store,
    methods: {
      signInWithGoogle: function() {
        var provider = new firebase.auth.GoogleAuthProvider();
        provider.setCustomParameters({ hd: 'fictiontribe.com' })

        var self = this;

        firebase.auth().signInWithPopup(provider).then(function(result) {
          // This gives you a Google Access Token. You can use it to access the Google API.
          var token = result.credential.accessToken;
          console.log(token);
          // The signed-in user info.
          var user = result.user;
          console.log(user);
          self.$store.dispatch('setTribeUser')
          if (self.isAdmin) {
            self.$router.replace('Admin')
          } else {
            self.$router.replace('Dashboard')
          }
          // ...
        }).catch(function(error) {
          // Handle Errors here.
          var errorCode = error.code;
          var errorMessage = error.message;
          // The email of the user's account used.
          var email = error.email;
          // The firebase.auth.AuthCredential type that was used.
          var credential = error.credential;
          // ...
        });
      },

      signIn: function() {
        firebase.auth().signInWithEmailAndPassword(this.email, this.password).then(
          (user) => {
            this.$store.dispatch('setUser')
            if (this.isAdmin) {
              this.$router.replace('Admin')
            } else {
              this.$router.replace('Dashboard')
            }
          },
          (err) => {
            alert('Oops. ' + err.message)
          }
        );
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .login {
    max-width: 450px !important;
  }
  input {
    margin: 10px 0;
    width: 100%;
    padding: 15px;
    border: 0;
    background-color: #f2f2f2;
    color: #000;
    font-weight: bold;
  }
  button {
    height: 50px;
    margin: 0 auto;
    margin-top: 20px;
    width: 50%;
    cursor: pointer;
  }
  p {
    margin-top: 40px;
    font-size: 13px;
  }
  p a {
    text-decoration: underline;
    cursor: pointer;
  }
  button#signin-btn {
    font-weight: bold;
    font-weight: bold;
    font-size: 1.1em;
    border-radius: 35px;
  }
  #login-card {
    padding: 40px;
  }
  @media (max-width: 769px) {
    .login {
      margin-top: 35%;
    }
    button {
      height: 40px;
    }
    button#signin-btn {
      font-size: 1em;
      padding-top: 8px;
    }
  }
  #customBtn {
    display: inline-block;
    background: white;
    color: #444;
    width: 260px;
    border-radius: 5px;
    border: thin solid #888;
    box-shadow: 1px 1px 1px grey;
    white-space: nowrap;
    padding: 5px 10px;
    margin-top: 30px;
  }
  #customBtn:hover {
    cursor: pointer;
  }
  span.label {
    font-family: serif;
    font-weight: normal;
  }
  span.icon {
    background: url('../assets/img/g-logo.png') transparent 5px 50% no-repeat;
    background-size: contain;
    display: inline-block;
    vertical-align: middle;
    width: 32px;
    height: 32px;
  }
  span.buttonText {
    display: inline-block;
    vertical-align: middle;
    padding-left: 12px;
    padding-right: 42px;
    font-size: 14px;
    font-weight: bold;
    /* Use the Roboto font that is loaded in the <head> */
    font-family: 'Roboto', sans-serif;
  }
</style>
